import { render, staticRenderFns } from "./InitialPage.vue?vue&type=template&id=19cebc50"
import script from "./InitialPage.vue?vue&type=script&lang=js"
export * from "./InitialPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports